import React, { Component } from 'react';
import Vas from '../Vas';
import '../css/Order.css';
import { CurrencyConverter } from 'utils-lib';

var Customer = null;
var Payment = null;
var From = null;
var To = null;
var Product = null;
var ContractStart = null;
var ContractEnd = null;
var DateOfBirth = null;
var AccountOwner = null;
//var AccountOwnerBirthDate = null;

class OrderSuccess2 extends Component
{
    constructor(props)
    {
        super(props);
        this.state = {};

        //Hier die Infos für die Vertragsübersicht auslesen
        DateOfBirth = localStorage.getItem('ContractOverviewCustomerBirthdate');
        Customer = JSON.parse(localStorage.getItem('ContractOverviewCustomer'));
        Payment = JSON.parse(localStorage.getItem('ContractOverviewCustomerPayment'));
        From = JSON.parse(localStorage.getItem('ContractOverviewTariffPointFrom'));
        To = JSON.parse(localStorage.getItem('ContractOverviewTariffPointTo'));
        Product = JSON.parse(localStorage.getItem('ContractOverviewTariffProduct'));
        ContractStart = localStorage.getItem('ContractOverviewContractStart');
        ContractEnd = localStorage.getItem('ContractOverviewContractEnd');
        AccountOwner = JSON.parse(localStorage.getItem('AccountOwner'));
        //AccountOwnerBirthDate = localStorage.getItem('AccountOwnerBirthDate');
    }

   render()
    {

      let personalData = '';
      let contractData = '';
      let payment = '';

      let AccountOwnerData = '';
      if(Customer !== null){
        personalData = (<table>
          <tbody>
            <tr>
              <td colSpan={5}>
                <br/>
                <br/>
                  <div id={"ContractDataHeadline"}>
                    <b>{Vas.Resources.Labels["Account"]} {Vas.Resources.Labels["TicketCustomer"]}</b>
                  </div>
                <br/>
                <br/>
              </td>
            </tr>
            <tr>
              <td>
                <div id={"PersonalData_LeftContainer"}>
                  <div id ={"PersonalData_NameHeadline"} style={{ fontSize:'14px', textAlign: 'left', width: '175px', float: 'left' }}><b>{Vas.Resources.Labels["Name"]}:</b></div>

                  <div id ={"PersonalData_Name"} style={{ fontSize:'14px', textAlign: 'left', float: 'right' }}>{Customer.Name1}</div>
                </div>

                <div id={"PersonalData_Empty"}></div>

                <div id={"PersonalData_RightContainer"}>
                  <div id ={"PersonalData_FirstNameHeadline"} style={{ fontSize:'14px', textAlign: 'left', width: '175px', float: 'left' }}><b>{Vas.Resources.Labels["FirstName"]}:</b></div>

                  <div id ={"PersonalData_FirstName"} style={{ fontSize:'14px', textAlign: 'left', float: 'right' }}>{ Customer.Name2 }</div>
                </div>  
              </td>
            </tr>
  
            <tr>
              <td>
                <div id={"PersonalData_LeftContainer"}>
                  <div id ={"PersonalData_DateOfBirthHeadline"} style={{ fontSize:'14px', textAlign: 'left', width: '175px', float: 'left' }}><b>{Vas.Resources.Labels["DateOfBirth"]}:</b></div>

                  <div id ={"PersonalData_DateOfBirth"} style={{ fontSize:'14px', textAlign: 'left', float: 'right' }}>{ DateOfBirth }</div>
                </div>

                <div id={"PersonalData_Empty"}></div>

                <div id={"PersonalData_RightContainer"}>
                  <div id ={"PersonalData_GenderHeadline"} style={{ fontSize:'14px', textAlign: 'left', width: '175px', float: 'left' }}><b>{Vas.Resources.Labels["Gender"]}:</b></div>

                  <div id ={"PersonalData_Gender"} style={{ fontSize:'14px', textAlign: 'left', float: 'right' }}>{ Customer.Gender }</div>
                </div>  
              </td>
            </tr>
  
            <tr>
              <td>
                <div id={"PersonalData_LeftContainer"}>
                  <div id ={"PersonalData_EmailHeadline"} style={{ fontSize:'14px', textAlign: 'left', width: '175px', float: 'left' }}><b>{Vas.Resources.Labels["Email"]}:</b></div>

                  <div id ={"PersonalData_Email"} style={{ fontSize:'14px', textAlign: 'left', float: 'right' }}>{ Customer.Email }</div>
                </div>

                <div id={"PersonalData_Empty"}></div>

                <div id={"PersonalData_RightContainer"}>
                  <div></div>
  
                  <div></div>
                </div>  
              </td>
            </tr>
  
            <tr>
              <td>
                <div id={"PersonalData_LeftContainer"}>
                  <div id ={"PersonalData_ZipHeadline"} style={{ fontSize:'14px', textAlign: 'left', width: '175px', float: 'left' }}><b>{Vas.Resources.Labels["Zip"]}:</b></div>
 
                  <div id ={"PersonalData_Zip"} style={{ fontSize:'14px', textAlign: 'left', float: 'right' }}>{Customer.PostCode}</div>
                </div>

                <div id={"PersonalData_Empty"}></div>

                <div id={"PersonalData_RightContainer"}>
                  <div id ={"PersonalData_PlaceHeadline"} style={{ fontSize:'14px', textAlign: 'left', width: '175px', float: 'left' }}><b>{Vas.Resources.Labels["Place"]}:</b></div>

                  <div id ={"PersonalData_Place"} style={{ fontSize:'14px', textAlign: 'left', float: 'right' }}>{ Customer.City }</div>
                </div>  
              </td>
            </tr>
  
            <tr>
              <td>
                <div id={"PersonalData_LeftContainer"}>
                  <div id ={"PersonalData_StreetHeadline"} style={{ fontSize:'14px', textAlign: 'left', width: '175px', float: 'left' }}><b>{Vas.Resources.Labels["Street"]}:</b></div>
              
                  <div id ={"PersonalData_Street"} style={{ fontSize:'14px', textAlign: 'left', float: 'right' }}>{ Customer.Street }</div>
                </div>

                <div id={"PersonalData_Empty"}></div>

                <div id={"PersonalData_RightContainer"}>
                  <div></div>

                  <div></div>
                </div>
              </td>
            </tr>
  
            <tr>
              <td>
                <div id={"PersonalData_LeftContainer"}>
                  <div id ={"PersonalData_HouseNumberHeadline"} style={{ fontSize:'14px', textAlign: 'left', width: '175px', float: 'left' }}><b>{Vas.Resources.Labels["HouseNumber"]}:</b></div>

                  <div id ={"PersonalData_HouseNumber"} style={{ fontSize:'14px', textAlign: 'left', float: 'right' }}>{ Customer.HouseNumber }</div>
                </div>

                <div id={"PersonalData_Empty"}></div>

                <div id={"PersonalData_RightContainer"}>
                  <div id ={"PersonalData_HouseNumberAdditionHeadline"} style={{ fontSize:'14px', textAlign: 'left', width: '175px', float: 'left' }}><b>{Vas.Resources.Labels["HouseNumberAddition"]}:</b></div>

                  <div id ={"PersonalData_HouseNumberAddition"} style={{ fontSize:'14px', textAlign: 'left', float: 'right' }}>{ Customer.HouseNumberAddition }</div>
                </div>  
              </td>
            </tr>
  
            <tr>
              <td>
                <div id={"PersonalData_LeftContainer"}>

                  <div id ={"PersonalData_AdditionAdressHeadline"} style={{ fontSize:'14px', textAlign: 'left', width: '175px',float: 'left' }}><b>{Vas.Resources.Labels["AdditionAdress"]}:</b></div>

                  <div id ={"PersonalData_AdditionAdress"} style={{ fontSize:'14px', textAlign: 'left', float: 'right' }}>{ Customer.Name3 }</div>

                </div>

                <div id={"PersonalData_Empty"}></div>

                <div id={"PersonalData_RightContainer"}>
                  <div></div>

                  <div></div>
                </div>
              </td>
            </tr>
          </tbody>
        </table>);
      }

      if(Payment !== null && From !== null && To !== null && Product !== null){
        
        if(Payment.BankName.length > 0){
          payment = (<table>
            <tbody>
              <tr>
                <td colSpan={5}>
                  <br/>
                  <br/>
                  <div id={"PaymentHeadline"}>
                    <b>{Vas.Resources.Labels["MethodOfPaymentCustomer"]}</b>
                  </div>
                  <br/>
                  <br/>
                </td>
              </tr>
              <tr>
                <td>
                <div id={"Payment_LeftContainer"}>
                  <div id ={"Payment_DepositorHeadline"} style={{ fontSize:'14px', textAlign: 'left', width:'175px', float: 'left' }}><b>{Vas.Resources.Labels["Depositor"]}:</b></div>

                  <div id ={"Payment_Depositor"} style={{ fontSize:'14px', textAlign: 'left', float: 'right' }}>{ Payment.AccountOwner }</div>

                  </div>

                    <div id={"Payment_Empty"}></div>

                    <div id={"Payment_RightContainer"}>

                  <div></div>

                  <div></div>
                  </div>
                </td>
              </tr>        

              <tr>
                <td>
                  <div id={"Payment_LeftContainer"}>
                    <div id ={"Payment_NameOfBankHeadline"} style={{ fontSize:'14px', textAlign: 'left', width: '175px', float: 'left' }}><b>{Vas.Resources.Labels["NameOfBank"]}:</b></div>

                    <div id ={"Payment_NameOfBank"} style={{ fontSize:'14px', textAlign: 'left', float: 'right' }}>{ Payment.BankName }</div>
                  </div>

                  <div id={"Payment_Empty"}></div>

                  <div id={"Payment_RightContainer"}>
                    <div></div>

                    <div></div>
                  </div>
                </td>
              </tr>
    
              <tr>
                <td>
                  <div id={"Payment_LeftContainer"}>
                    <div id ={"Payment_IbanHeadline"} style={{ fontSize:'14px', textAlign: 'left', width: '175px', float: 'left' }}><b>{Vas.Resources.Labels["Iban"]}:</b></div>

                    <div id ={"Payment_Iban"} style={{ fontSize:'14px', textAlign: 'left', float: 'right' }}>{ '**' + Payment.Iban.substr(18, 4) }</div>
                  </div>

                  <div id={"Payment_Empty"}></div>

                  <div id={"Payment_RightContainer"}>
                    <div></div>
  
                    <div></div>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>)
        }

        let connectionData = "";
        let fromToConnectionData = "";
        let viaConnectionData = "";
        let validInData = "";

        if((Product.TzFromText !== "" && Product.TzFromText !== 'null') &&
        !(Product.TicketIdent == "01-37-02" || 
        Product.TicketIdent == "01-45-02" || 
        Product.TicketIdent == "01-43-02" || 
        Product.TicketIdent == "01-47-02")){
          connectionData = (<tr>
            <td colSpan={5}>
              <br/>
              <br/>
              <div id={"ContractDataConnectionHeadline"}>
                <b>{Vas.Resources.Labels["ConnectionData"]}</b>
              </div>
              <br/>
              <br/>
            </td>
          </tr>);

          if(Product.TicketIdent == "01-35-02" || 
          Product.TicketIdent == "01-38-02"){
            if(Product.TzFromText == Product.TzToText){

              if(Product.PriceLevel == "kleiner Stadtverkehr"){
                validInData = (<tr>
                  <td>
                    <div id={"ContractData_LeftContainer"}>
                      <div id={"ContractData_ViaHeadline"} style={{ fontSize:'14px', textAlign: 'left', width: '175px', float: 'left' }}><b>Gültig in:</b></div>

                      <div id={"ContractData_Via"} style={{ fontSize:'14px', textAlign: 'left', float: 'right' }}>{ Product.PriceLevel }</div>
                    </div>

                    <div id={"ContractData_Empty"}></div>

                    <div id={"ContractData_RightContainer_Empty"}>
                      <div></div>

                      <div></div>
                    </div>
                  </td>
                </tr>);
              }else{
                validInData = (<tr>
                  <td>
                    <div id={"ContractData_LeftContainer"}>
                      <div id={"ContractData_ViaHeadline"} style={{ fontSize:'14px', textAlign: 'left', width: '175px', float: 'left' }}><b>Gültig in:</b></div>

                      <div id={"ContractData_Via"} style={{ fontSize:'14px', textAlign: 'left', float: 'right' }}>{ "Zone " + Product.TzFromText}</div>
                    </div>

                    <div id={"ContractData_Empty"}></div>

                    <div id={"ContractData_RightContainer_Empty"}>
                      <div></div>

                      <div></div>
                    </div>
                  </td>
                </tr>);
              }
            }

          }else{
            fromToConnectionData = (<tr>
              <td>
                <div id={"ContractData_LeftContainer"}>
                  <div id ={"ContractData_FromHeadline"} style={{ fontSize:'14px', textAlign: 'left', width: '175px', float: 'left' }}><b>{Vas.Resources.Labels["From"]}:</b></div>
      
                  <div id ={"ContractData_From"} style={{ fontSize:'14px', textAlign: 'left', float: 'right' }}>{ "Zone " + Product.TzFromText}</div>
                </div>
      
                <div id={"ContractData_Empty"}></div>
      
                <div id={"ContractData_RightContainer"}>
                  <div id ={"ContractData_ToHeadline"} style={{ fontSize:'14px', textAlign: 'left', width: '175px', float: 'left'}}><b>{Vas.Resources.Labels["To"]}:</b></div>
      
                  <div id ={"ContractData_To"} style={{ fontSize:'14px', textAlign: 'left', float: 'right' }}>{ "Zone " + Product.TzToText }</div>
                </div>
              </td>
            </tr>);
  
            viaConnectionData = (<tr>
              <td>
                <div id={"ContractData_LeftContainer"}>
                  <div id ={"ContractData_ViaHeadline"} style={{ fontSize:'14px', textAlign: 'left', width: '175px', float: 'left' }}><b>{Vas.Resources.Labels["Via"]}:</b></div>
      
                  <div id ={"ContractData_Via"} style={{ fontSize:'14px', textAlign: 'left', float: 'right' }}>{ Product.TzViaText }</div>
                </div>
      
                <div id={"ContractData_Empty"}></div>
      
                <div id={"ContractData_RightContainer"}>
                  <div></div>
      
                  <div></div>
                </div>
              </td>
            </tr>);
          }
        }

        contractData = (<table>
          <tbody>
          <tr>
              <td
                colSpan={5}>
                  <br/>
                  <br/>
                  <div id={"ContractDataHeadline"}>
                    <b>{Vas.Resources.Labels["ContractData"]}</b>
                  </div>
                  <br/>
                  <br/>
                  </td>
            </tr>
            <tr>
              <td>
                <div id={"ContractData_LeftContainer"}>
                  <div id ={"ContractData_ContractStartHeadline"} style={{ fontSize:'14px', textAlign: 'left', width: '175px', float: 'left' }}><b>{Vas.Resources.Labels["ContractStart"]}:</b></div>

                  <div id ={"ContractData_ContractStart"} style={{ fontSize:'14px', textAlign: 'left', float: 'right' }}>{ContractStart}</div>
                </div>

                <div id={"ContractData_Empty"}></div>

                <div id={"ContractData_RightContainer"}>
                  <div id ={"ContractData_ContractEndHeadline"} style={{ fontSize:'14px', textAlign: 'left', width: '175px', float: 'left' }}><b>{Vas.Resources.Labels["ContractEnd"]}:</b></div>

                  <div id ={"ContractData_ContractEnd"} style={{ fontSize:'14px', textAlign: 'left', float: 'right' }}>{ContractEnd }</div>

                </div>
              </td>
            </tr>
  
            <tr>
              <td>
                <div id={"ContractData_LeftContainer"}>
                  <div id ={"ContractData_ProductPriceHeadline"} style={{ fontSize:'14px', textAlign: 'left', width: '175px', float: 'left' }}><b>{Vas.Resources.Labels["ProductPrice"]}:</b></div>

                  <div id ={"ContractData_ProductPrice"} style={{ fontSize:'14px', textAlign: 'left', float: 'right' }}>{ CurrencyConverter.Cast( Product.Price, localStorage.getItem("vas_language") ,2) }</div>
                </div>

                <div id={"ContractData_Empty"}></div>

                <div id={"ContractData_RightContainer"}>
                  <div id ={"ContractData_PriceLevelHeadline"} style={{ fontSize:'14px', textAlign: 'left', width: '175px', float: 'left' }}><b>{Vas.Resources.Labels["PriceLevel"]}:</b></div>
  
                  <div id ={"ContractData_PriceLevel"} style={{ fontSize:'14px', textAlign: 'left', float: 'right' }}>{ Product.PriceLevel }</div>
                </div>
              </td>
            </tr>
  
            <tr>
              <td>
                <div id={"ContractData_LeftContainer"}>
                  <div id ={"ContractData_TicketNameHeadline"} style={{ fontSize:'14px', textAlign: 'left', width: '175px', float: 'left' }}><b>{Vas.Resources.Labels["TicketName"]}:</b></div>

                  <div id ={"ContractData_TicketName"} style={{ fontSize:'14px', textAlign: 'left', float: 'right' }}>{ Product.TicketName }</div>
                </div>

                <div id={"ContractData_Empty"}></div>

                <div id={"ContractData_RightContainer"}>
                  <div></div>

                  <div></div>
                </div>
              </td>
            </tr>
  
            {connectionData}

            {fromToConnectionData}
  
            {viaConnectionData}

          </tbody>
        </table>);
      }

      if(AccountOwner !== null){
        AccountOwnerData = (<table>
          <tbody>
            <tr>
              <td colSpan={5}>
                <br/>
                <br/>
                <div id={"AccountOwnerDataHeadline"}>
                  <b>Persönliche Daten Kontoinhaber</b>
                </div>
                <br/>
                <br/>
              </td>
            </tr>
            <tr>
              <td>
                <div id={"AccountOwnerData_LeftContainer"}>
                  <div id ={"AccountOwnerData_Gender"} style={{ fontSize:'14px', textAlign: 'left', width: '175px', float: 'left' }}><b>{Vas.Resources.Labels["Gender"]}:</b></div>
                
                  <div id ={"AccountOwnerData_Gender"} style={{ fontSize:'14px', textAlign: 'left', float: 'right' }}>{AccountOwner.Gender}</div>

                </div>
              </td>
            </tr>
            <tr>
              <td>
                <div id={"AccountOwnerData_LeftContainer"}>
                  <div id ={"AccountOwnerData_ZipHeadline"} style={{ fontSize:'14px', textAlign: 'left', width: '175px', float: 'left' }}><b>{Vas.Resources.Labels["Zip"]}:</b></div>
                
                  <div id ={"AccountOwnerData_Zip"} style={{ fontSize:'14px', textAlign: 'left', float: 'right' }}>{AccountOwner.Zip}</div>

                </div>

                <div id={"AccountOwnerData_Empty"}></div>

                <div id={"AccountOwnerData_RightContainer"}>

                  <div id ={"AccountOwnerData_PlaceHeadline"} style={{ fontSize:'14px', textAlign: 'left', width: '175px', float: 'left' }}><b>{Vas.Resources.Labels["Place"]}:</b></div>

                  <div id ={"AccountOwnerData_Place"} style={{ fontSize:'14px', textAlign: 'left', float: 'right' }}>{ AccountOwner.City }</div>
                </div>
              </td>
            </tr>
  
            <tr>
              <td>
                <div id={"AccountOwnerData_LeftContainer"}>
                  <div id ={"AccountOwnerData_StreetHeadline"} style={{ fontSize:'14px', textAlign: 'left', width: '175px', float: 'left' }}><b>{Vas.Resources.Labels["Street"]}:</b></div>

                  <div id ={"AccountOwnerData_Street"} style={{ fontSize:'14px', textAlign: 'left', float: 'right' }}>{ AccountOwner.Street }</div>
                  </div>

                <div id={"AccountOwnerData_Empty"}></div>

                <div id={"AccountOwnerData_RightContainer"}>

                  <div></div>

                  <div></div>
                </div>
              </td>
            </tr>
  
            <tr>
              <td>
                <div id={"AccountOwnerData_LeftContainer"}>
                  <div id ={"AccountOwnerData_HouseNumberHeadline"} style={{ fontSize:'14px', textAlign: 'left', width: '175px', float: 'left' }}><b>{Vas.Resources.Labels["HouseNumber"]}:</b></div>

                  <div id ={"AccountOwnerData_HouseNumber"} style={{ fontSize:'14px', textAlign: 'left', float: 'right' }}>{ AccountOwner.HouseNumber }</div>
                </div>

                <div id={"AccountOwnerData_Empty"}></div>

                <div id={"AccountOwnerData_RightContainer"}>

                  <div id ={"AccountOwnerData_HouseNumberAdditionHeadline"} style={{ fontSize:'14px', textAlign: 'left', width: '175px', float: 'left' }}><b>{Vas.Resources.Labels["HouseNumberAddition"]}:</b></div>

                  <div id ={"AccountOwnerData_HouseNumberAddition"} style={{ fontSize:'14px', textAlign: 'left', float: 'right' }}>{ AccountOwner.HouseNumberAddition }</div>
                </div>
              </td>
            </tr>
  
            <tr>
              <td>
                <div id={"AccountOwnerData_LeftContainer"}>
                  <div id ={"AccountOwnerData_AdditionAdressHeadline"} style={{ fontSize:'14px', textAlign: 'left', width: '175px', float: 'left' }}><b>{Vas.Resources.Labels["AdditionAdress"]}:</b></div>

                  <div id ={"AccountOwnerData_AdditionAdress"} style={{ fontSize:'14px', textAlign: 'left', float: 'right' }}>{ AccountOwner.Name3 }</div>

                </div>

                <div id={"AccountOwnerData_Empty"}></div>

                <div id={"AccountOwnerData_RightContainer"}>

                  <div></div>
                
                  <div></div>
                </div>
              </td>
            </tr>
          </tbody>
        </table>);
      }

        return ( <div className="LoginContainer">
          <div className={"form orderSuccess2Form"} style={{minWidth:'560px'}}>
            <table>
              <thead>
                <tr>
                  <th colSpan={2}><h2>{Vas.Resources.Labels["OrderSuccessfully"]}</h2></th>
                </tr>
              </thead>
              <tbody>
                <tr>
                <td colSpan={2} className={"HintOrderWorkingOn"}>
                  {Vas.Resources.Labels["OrderWorkingOn"]}
                </td>
                </tr>
              </tbody>
            </table>

            {personalData}

            {contractData}

            {payment}
            {AccountOwnerData}
          </div>
        </div>);
    }
}
export default OrderSuccess2;
